import { handleNetworkResponseAndGetJsonAsync, handleNetworkResponseWithNoPayloadAsync, Network } from './Network'
import { GlobalVars } from '../../global'
import { GetInvoicesResponse } from './collections/invoice/getListOfInvoices/getListOfInvoices_200'
import { GetInvoiceIssuersResponse } from './collections/invoice/getListOfInvoiceIssuers/getListOfInvoiceIssuers_200'
import { CreateInvoiceIssuerResponse } from './collections/invoice-Issuer/createInvoiceIssuer/createInvoiceIssuer_200'
import { CreateInvoiceIssuerDto } from './sharedTypes/Invoice'
import { UpdateInvoiceIssuerResponse } from './collections/invoice-Issuer/updateInvoiceIssuer/updateInvoiceIssuer_200'
import { UpdateInvoiceIssuerRequest } from './collections/invoice-Issuer/updateInvoiceIssuer/updateInvoiceIssuer_post'
import { ConvertObjectToFormData } from '../../utils/global-utils'
import { GetInvoiceIssuerResponse } from './collections/invoice-Issuer/getInvoiceIssuerDetail/getInvoiceIssuerDetail_200'
import { GetInvoiceResponse } from './collections/invoice/getInvoiceDetail/getInvoiceDetail_200'
import { UploadInvoiceIssuerImageRequest } from './collections/invoice-Issuer/uploadImage/uploadImage_post'
import { ForcePaymentCheckResultDto } from './collections/invoice/forcePaymentCheck/forcePaymentCheck_200'

export class InvoiceManager {
    static _instance: InvoiceManager | null = null

    static getManager(): InvoiceManager {
        if (this._instance === null) {
            this._instance = new InvoiceManager()
        }
        return this._instance
    }

    async getInvoiceListAsync(): Promise<GetInvoicesResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/invoice`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: GetInvoicesResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async getInvoiceAsync(id: string): Promise<GetInvoiceResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/invoice/${id}`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: GetInvoiceResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async getInvoiceListFilteredAsync(dateFrom: string, dateTo: string): Promise<GetInvoicesResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/invoice?issueDateFrom=${dateFrom}&issueDateTo=${dateTo}`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: GetInvoicesResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async getInvoiceIssuerListAsync(): Promise<GetInvoiceIssuersResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/invoice/issuer`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: GetInvoiceIssuersResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async getInvoiceIssuerDetailAsync(id: string): Promise<GetInvoiceIssuerResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/invoice/issuer/${id}`
        try {
            response = await Network.fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: GetInvoiceIssuerResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async createInvoiceIssuerAsync(issuer: CreateInvoiceIssuerDto): Promise<CreateInvoiceIssuerResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/invoice/issuer/create`
        const body: CreateInvoiceIssuerDto = issuer
        try {
            response = await Network.fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: CreateInvoiceIssuerResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async deleteInvoiceIssuerAsync(id: string): Promise<void> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/invoice/issuer/${id}`
        try {
            response = await Network.fetch(url, {
                method: 'DELETE',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result = await handleNetworkResponseWithNoPayloadAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async updateInvoiceIssuerAsync(id: string, issuer: UpdateInvoiceIssuerRequest): Promise<UpdateInvoiceIssuerResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/invoice/issuer/${id}/update`
        const body: UpdateInvoiceIssuerRequest = issuer

        try {
            response = await Network.fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: UpdateInvoiceIssuerResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async uploadInvoiceIssuerImageAsync(id: string, imageFile?: File): Promise<UpdateInvoiceIssuerResponse> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/invoice/issuer/${id}/image/upload`
        const body: UploadInvoiceIssuerImageRequest = { imageFile: imageFile }
        const formData = ConvertObjectToFormData(body)

        try {
            response = await Network.fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                },
                body: formData,
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: UpdateInvoiceIssuerResponse = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async forcePaymentCheckAsync(): Promise<ForcePaymentCheckResultDto> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/invoice/force-payment-check`
        try {
            response = await Network.fetch(url, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result: ForcePaymentCheckResultDto = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }

    async deleteInvoiceAsync(id: string): Promise<void> {
        let response: Response | null = null
        const url = `${GlobalVars.SERVER_ENDPOINT}/invoice/${id}`
        try {
            response = await Network.fetch(url, {
                method: 'DELETE',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            })
        } catch (e) {
            throw new Error('Error executing fetch request.')
        }
        if (response) {
            const result = await handleNetworkResponseAndGetJsonAsync(response)
            return result
        } else {
            throw new Error('No response from server returned.')
        }
    }
}
